import { createAction } from 'redux-actions';
import { PapiSubscriptionV3 } from '@wix/da-papi-types';
import { createCallbackActionCreator } from '@wix/da-shared-react/pkg/Stream/helpers';

export const deleteCard = createAction(`BILLING.DELETE_CARD`, (cardId: number) => ({
  cardId,
}));

export const removeCardFromList = createAction(`BILLING.DELETE_CARD_SUCCESS`, (cardId: number) => ({
  cardId,
}));

export const cancelCore = createAction(`BILLING.CANCEL_CORE`, (orderId: number) => ({
  orderId,
}));

export const removeCoreSubscription = createAction(`BILLING.CANCEL_CORE_SUCCESS`, () => ({}));

export type CancellationReasonString = '1' | '2' | '3' | '4' | '5' | undefined;
export const cancelMemberSubscription = createAction(
  'BILLING.CANCEL_MEMBER_SUB',
  (payload: { orderId: number; reason?: CancellationReasonString }) => payload
);

export const removeMemberSubscription = createAction(
  `BILLING.CANCEL_MEMBER_SUB_SUCCESS`,
  (orderId: number) => ({
    orderId,
  })
);

export const fetchNextOrders = createCallbackActionCreator('BILLING.FETCH_NEXT_ORDERS');

export const viewSubscriptionReceipt = createAction(
  `BILLING.VIEW_SUBSCRIPTION_RECEIPT`,
  (subscription: PapiSubscriptionV3) => ({ subscription })
);
